import {
  faBookmark,
  faSquareSliders,
} from "@fortawesome/duotone-light-svg-icons"
import { Button } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useShallow } from "zustand/react/shallow"

import AddAIQuestButton from "./AddAIQuestButton"
import { useAddEditQuestStore } from "./addEditQuestModal/useAddEditQuestStore"
import { useAddQuestTemplatesModalStore } from "./addQuestTemplates/useAddQuestTemplatesModalStore"
import useQuestBoardMultiSelectStore from "./useQuestBoardMultiSelectStore"
import AnimatedButtonGroup from "../../components/buttonGroup/AnimatedButtonGroup"

export const AddQuestButton = () => {
  const { onOpen: openAddQuestTemplatesModal } =
    useAddQuestTemplatesModalStore()
  const { onOpen: onOpenAddEditQuestModal } = useAddEditQuestStore()
  const { t } = useTranslation()

  const { isMultiSelectMode } = useQuestBoardMultiSelectStore(
    useShallow((state) => ({ isMultiSelectMode: state.isMultiSelectMode }))
  )

  if (isMultiSelectMode) return <></>

  return (
    <AnimatedButtonGroup>
      <Button
        onClick={() => onOpenAddEditQuestModal()}
        icon={faSquareSliders}
        text={t("QB_CUSTOM_QUEST")}
      />
      <Button
        onClick={() => openAddQuestTemplatesModal()}
        icon={faBookmark}
        text={t("QB_START_FROM_TEMPLATE")}
      />
      <AddAIQuestButton />
    </AnimatedButtonGroup>
  )
}

export default AddQuestButton
